import React from 'react';
import { NavLink } from "react-router-dom";
const RegularLink = (props) => {
    return (React.createElement(NavLink, { to: props.to, className: "text-[#cf4dff]" },
        " ",
        props.label,
        " "));
};
export default RegularLink;
